import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { UserAccountRoutingModule } from './user-account-routing.module';
import { AccountHomeComponent } from './account-home/account-home.component';
import { VerticalMenuTypeOneModule } from '../navigation';
import { UserAccountDetailsUpdateComponent } from './user-account-details-update/user-account-details-update.component';
import { EmailInputFormComponent, UserAvatarPipe } from '@frontend/shared';
import { AlertModule } from 'ngx-bootstrap/alert';
import { TranslocoModule, TRANSLOCO_SCOPE } from '@jsverse/transloco';
import { LoaderGlobeAnimationDetailComponent } from '../loaders';
import { ReactiveFormsModule } from '@angular/forms';
import { AccountNotificationsComponent } from './notifications/account-notifications.component';
// import { UserAccountConsentComponent } from './consent/user-account-consent/user-account-consent.component';


@NgModule({
  declarations: [
    AccountHomeComponent,
    // UserAccountConsentComponent
  ],
  providers: [{ provide: TRANSLOCO_SCOPE, useValue: 'account' }],
  imports: [
    CommonModule,
    UserAccountDetailsUpdateComponent,
    ReactiveFormsModule,
    UserAccountRoutingModule,
    TranslocoModule,
    VerticalMenuTypeOneModule,
    EmailInputFormComponent,
    AlertModule,
    LoaderGlobeAnimationDetailComponent,
    AccountNotificationsComponent,
    UserAvatarPipe,
  ],
})
export class UserAccountModule { }
